import { Component, OnDestroy } from '@angular/core';
import { MessageService } from '../message/message.service';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { takeUntil } from 'rxjs/operators';
import { TabService } from '../../services/tab.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'bm-ext-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnDestroy {

  private readonly destroy$ = new Subject<void>();

  isSubmitting = false;
  isEnforceSubmitting = false;
  isPurchaseSubmitting = false;

  constructor(
    private readonly api: ApiService,
    private readonly messageService: MessageService,
    private readonly router: Router,
    private readonly tabService: TabService
  ) {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  enforce() {
    const url = this.tabService.url$.value;
    this.isSubmitting = this.isEnforceSubmitting = true;
    this.api.post('v2/extension/detect', { Url: url.origin + url.pathname })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.handleSuccess(),
        error: () => this.isSubmitting = this.isEnforceSubmitting = false
      });
  }

  purchase() {
    const url = this.tabService.url$.value;
    this.isSubmitting = this.isPurchaseSubmitting = true;
    this.api.post('v2/extension/purchase', { Url: url.origin + url.pathname })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => this.handleSuccess(),
        error: () => this.isSubmitting = this.isPurchaseSubmitting = false
      });
  }

  private handleSuccess() {
    this.messageService.message$.next({
      icon: 'done',
      title: 'Запрос отправлен',
      body: `
        Вы можете отслеживать статус в <a href="${ environment.siteUrl }" class="link" target="_blank">личном кабинете</a>
      `
    });
    this.router.navigate(['message']);
  }

}
